const maps = {
    'section-type': {
        0: '混合',
        1: '文档',
        2: '图文',
        3: 'URL',
        4: 'H5',
        5: '音频',
        6: '视频',
        7: 'EPUB电子书',
        8: '作业',
        9: '考试',
        10: '课程',
        11: '面授',
        12: '调研',
        13: '评估',
        14: '直播',
        16: '视频地址',
        17: '直播'
    },
    'office-index-type': {
        8: '作品',
        7: '阅卷',
        6: '监考',
        5: '审批',
        4: '授课',
        3: '培训',
        2: '提报',
        1: '批改'
    },
    'office-nav-name': {
        8: 'Review of Works',
        7: 'Examination Marking',
        6: 'Exam invigilation',
        5: 'Task approval',
        4: 'Teaching Arrangements',
        3: 'Shift Management',
        2: 'Class report',
        1: 'Homework Correction'
    },
    'live-status': {
        1: '未开始',
        2: '进行中',
        3: '已结束',
        4: '未发布',
    },
    'research-status': {
        2: '未开始',
        3: '进行中',
        4: '已结束',
    },
    'exam-status': {
        1: '未发布',
        2: '发布中',
        3: '未开始',
        4: '报名中',
        5: '开考中',
        6: '已结束',
    },
    'train-status': {
        2: '策划中',
        3: '报名中',
        4: '待实施',
        5: '实施中',
        6: '待结项',
        7: '已结项',
        8: '已撤销',
    },
    'train-type': {
        0: '内部培训',
        1: '外派培训'
    },
    'train-type-abbr': {
        0: '内部',
        1: '外派'
    },
    'train-class-type': {
        1: '培训班',
        2: '专题班',
        3: '外派培训'
    },
    'train-class-type-abbr': {
        1: '培训班',
        2: '专题班',
        3: '外派'
    },
    'putforward-status': {
        0: '未提报',
        1: '提报中',
        2: '已过期'
    },
    'markpaper-source': {
        5: '直播',
        4: '培训',
        3: '专题',
        2: '课程',
        1: '考试'
    },
    'lecturer-type-abbr': {
        // 0: '面授',
        // 1: '直播'
        1: '面授',
        2: '直播',
        3: '其他',
        4: '直播'
    },
    'lecturer-type': {
        // 0: '面授课程',
        // 1: '直播课程'
        1: '面授课程',
        2: '直播课程',
        3: '其他课程'
    },
    'homework-type': {
        3: '其它',
        2: '培训',
        1: '专题',
        0: '课程'
    },
    'finish-status': {
        3: '未开始',
        1: '进行中',
        2: '已完成'
    },
    'approve-result': {
        1: '已同意',
        2: '已撤销',
        0: '已拒绝',
        4: '审批中',

    },
    'approve-business-type': {
        1: '课程'
    },
    'homework-result': {
        1: '驳回',
        2: '通过'
    },
    // -------xhf-------
    'type-colors': {
        1: '233,164,89', // 课程
        2: '231,132,132', // 专题
        3: '68,193,191', // 考试
        4: '52,157,31', // 调研
        5: '0,174,255', // 班级
        6: '89,145,233', // 直播
        7: '68,193,191' // 认证考试
    },
    'status-colors': {
        1: '96,200,189', // 未开始
        2: '0,174,255', // 进行中
        3: '240,114,80', // 报名中
        4: '238,103,103', // 策划中
        5: '90,175,116', // 待实施
        6: '104,152,220', // 实施中
        7: '167,131,89' // 待结项
    },
    'warning-colors': {
        1: '#F00', // 0%-50% 红色警告
        2: '#FF0', // 50%-75% 黄色显示
        3: '#00AEFF', // 50%-75% 蓝色显示
    },
    'source-form': {
        1: '学习推送',
        2: '群主',
        3: '岗位',
        4: '职务',
        5: '主管'
    },
    'type-text': {
        1: '课程',
        2: '专题',
        3: '考试',
        4: '调研',
        5: '班级',
        6: '直播',
        7: '认证考试'
    },
    'exam-detail-status': {
        1: '未发布',
        2: '发布中',
        3: '未开始',
        4: '报名中',
        5: '开考中',
        6: '已结束',
        7: '信息更新中',
    },
    'exam-type': {
        1: '普通考试',
        3: '认证考试',
        4: '认证考试'
    },
    'exam-record-status': {
        1: '未开始',
        2: '进行中',
        4: '交卷异常',
        5: '待评卷',
        6: '及格',
        7: '不及格',
        8: '已完成',
        9: '良好',
        10: '优秀'

    },
    'exam-record-qualified': {
        1: '未开始',
        2: '进行中',
        4: '交卷异常',
        5: '待评卷',
        6: '合格',
        7: '不及格',
        8: '已完成',
        9: '良好',
        10: '优秀'

    },
    'research-record-status': {
        0: '未参与',
        1: '已参与',
    },
    'required-type': {
        0: '选修',
        1: '必修'
    },
    'content-type': {
        1: 'Files',
        2: 'Picture',
        4: 'Compressed file',
        5: 'Audio',
        6: 'Video',
        7: 'EPUB e-book',
        10: 'Other',
    },
    'translate-type': {
        0: 'In conversion',
        1: 'Conversion completed',
        2: 'Conversion failed'
    },
    // -------qzm-------
    // -------hhy-------
    'ask-subject-type': {
        1: '内容',
        2: '讨论',
        3: '回复',
    },
    'ask-merge-status': {
        1: '待审核',
        2: '已拒绝',
        3: '已关闭',
    },
    // -------zq-------
    'game-status': {
        1: '未开始',
        2: '进行中',
        3: '已结束'
    },
    'income-type': {
        1: '收入',
        2: '支出'
    },
};

export { maps as default };

